import { render, staticRenderFns } from "./BaseStatusTile.vue?vue&type=template&id=55ca140f&scoped=true&lang=pug&"
import script from "./BaseStatusTile.vue?vue&type=script&lang=js&"
export * from "./BaseStatusTile.vue?vue&type=script&lang=js&"
import style0 from "./BaseStatusTile.vue?vue&type=style&index=0&id=55ca140f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ca140f",
  null
  
)

export default component.exports